module.exports = __webpack_public_path__ + "static/img/basestation.ead1abd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/basestation.jpg
// module id = nsUd
// module chunks = 2